export const localeKg = {
  days: ['Жекшемби', 'Дүйшөмбү', 'Шейшемби', 'Шаршемби', 'Бейшемби', 'Жума', 'Ишемби'],
  daysShort: ['Жек', 'Дүй', 'Шей', 'Шар', 'Бей', 'Жум', 'Ише'],
  daysMin: ['Жк', 'Дш', 'Шш', 'Шр', 'Бш', 'Жм', 'Иш'],

  months: [
    'Үчтүн айы',       // январь
    'Жалган куран',    // февраль
    'Наристе',         // март
    'Куран',           // апрель
    'Бугу',            // май
    'Кулжа',           // июнь
    'Теке',            // июль
    'Баш оона',        // август
    'Аяк оона',        // сентябрь
    'Тогуздун айы',    // октябрь
    'Жетинин айы',     // ноябрь
    'Бештин айы'       // декабрь
  ],
  monthsShort: [
    'Үчт', 'Жк', 'Нар', 'Кур', 'Буг', 'Кул',
    'Тек', 'Баш', 'Аяк', 'Тог', 'Жет', 'Беш'
  ],

  today: 'Бүгүн',
  clear: 'Тазалоо',
  dateFormat: 'dd.MM.yyyy',
  timeFormat: 'HH:mm',
  firstDay: 1
}
